<template>
  <div>
    <vx-card heading-size="h1" title="Welcome">
      <p>Welcome to Virtual Job Experience {{ name }},</p>
      <vs-divider />
      <p class="mb-5">
        This platform enables you to really see what a job is all about without setting foot into
        the actual workplace. You can have one or multiple experiences, complete tasks and
        activities that are typical of that job, and get a certificate of completion at the end.
      </p>
      <p>
        <strong>Please Note:</strong> When completing work, remember to SAVE as you go. This
        platform will log you out after 20 minutes of inactivity.
      </p>
    </vx-card>

    <vx-card headingSize="h2" title="What would you like to do?">
      <div role="list" class="home-cta">
        <div role="listitem" class="cta">
          <router-link
            tag="button"
            to="/student/available-experiences"
            class="btn btn-primary btn-size-medium btn-block h-100"
          >
            Start a virtual experience
          </router-link>
        </div>
        <div role="listitem" class="cta">
          <button
            :aria-disabled="incomplete_experiences.length === 0"
            @click="continueVje()"
            role="link"
            class="btn btn-secondary btn-size-medium btn-block h-100"
          >
            Continue a virtual experience
          </button>
        </div>
        <div role="listitem" class="cta">
          <router-link
            tag="button"
            to="/student/experiences/completed"
            class="btn btn-secondary btn-size-medium btn-block h-100"
          >
            View completed virtual experiences
          </router-link>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import store from '@/store/store';

export default {
  computed: {
    incomplete_experiences() {
      return store.getters['authStudent/experiences'].filter((e) => {
        return !e.completed;
      });
    },
    fname() {
      return store.getters['authStudent/fName'];
    },
  },
  data() {
    return {
      name: this.fname,
    };
  },
  methods: {
    continueVje() {
      if (this.incomplete_experiences.length === 0) {
        return;
      }
      this.$router.push('/student/experiences/continue');
    },
  },
  watch: {
    fname() {
      this.name = this.fname;
    },
  },
  mounted() {
    this.name = this.fname;
  },
};
</script>

<style scoped lang="scss">
.home-cta {
  display: flex;
  justify-content: center;
  padding: 0 12px;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
  .cta {
    flex-grow: 1;
    flex-basis: 0;
    margin: 0 10px;

    @media only screen and (max-width: 768px) {
      margin: 10px 0;
    }
  }
}
</style>
